import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  const tagColors: Record<string, string> = {
    '新片上线': 'bg-accent-500/15 text-accent-600',
    '系统升级': 'bg-secondary-500/15 text-secondary-600',
    '独家内容': 'bg-primary-500/15 text-primary-600',
    '频道上线': 'bg-secondary-500/15 text-secondary-600',
    '剧集更新': 'bg-primary-500/15 text-primary-600',
    '网络优化': 'bg-secondary-500/15 text-secondary-600',
  };

  return (
    <section id="updates" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">最新上架</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            平台每日更新动态，新片上线、系统升级一手掌握
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updateItems.map((item, index) => (
            <div
              key={item.id}
              className="relative flex gap-4 md:gap-6 pb-8 last:pb-0"
            >
              <div className="flex flex-col items-center flex-shrink-0">
                <div className={`w-3 h-3 rounded-full border-2 ${index === 0 ? 'bg-primary-500 border-primary-500' : 'bg-background-300 border-background-300'}`}></div>
                {index < updateItems.length - 1 && (
                  <div className="w-px flex-1 bg-background-200 mt-1.5"></div>
                )}
              </div>

              <div className="flex-1 min-w-0 pb-2">
                <div className="flex items-center gap-3 flex-wrap mb-1">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}